import {
  Box,
  CssBaseline,
  ThemeProvider,
  createTheme,
  responsiveFontSizes,
} from "@mui/material";
import { PropsWithChildren } from "react";

import themeConfig from "../../lib/themeConfig";
import ModalContextProvider from "../modal/ModalContextProvider";
import FontFace from "../theme/FontFace";

import Footer from "./Footer";
import Navigation from "./Navigation";

const theme = responsiveFontSizes(createTheme(themeConfig));

const Layout = ({ children }: PropsWithChildren) => {
  return (
    <ThemeProvider theme={theme}>
      <ModalContextProvider>
        <FontFace />
        <Navigation />
        <CssBaseline />
        <Box
          sx={{ minHeight: "calc(100vh - 5.5em - 4em)", paddingBottom: "5em" }}
        >
          {children}
        </Box>
        <Footer />
      </ModalContextProvider>
    </ThemeProvider>
  );
};

export default Layout;
